import Clue1 from "./pages/Clue1";
import Unlock from "./pages/Unlock";
import "./App.css"

const unlocked = true;

function App() {
  if (unlocked === true ) { //To change after groupchat is made
    return (<Unlock/>);
  } else {
    return (
      <div className="App">
        <Clue1 />
      </div>
    );
  }
}

export default App;
